import {
  NgbModal,
  NgbModalRef,
  NgbModalOptions
} from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable()
export class ModalService {
  private openedModals: NgbModalRef[] = [];

  constructor(private ngbModal: NgbModal) {}

  get contextModals(): NgbModalRef[] {
    return this.openedModals;
  }

  open(content: any, modalOptions?: NgbModalOptions): NgbModalRef {
    const modalRef = this.ngbModal.open(content, modalOptions);
    this.openedModals.push(modalRef);
    return modalRef;
  }

  dismiss(reason?: any) {
    const modalRef = this.openedModals.pop();
    modalRef.dismiss(reason);
  }

  close() {
    const modalRef = this.openedModals.pop();
    modalRef.close();
  }

  closeAll() {
    this.openedModals.forEach(modalRef => modalRef.close());
    this.openedModals = [];
  }

  dismissAll(reason?: any) {
    this.openedModals.forEach(modalRef => modalRef.dismiss(reason));
    this.openedModals = [];
  }

  handleClickOutside(modal, previouslyFocusedInput) {
    setTimeout(() => {
      document.addEventListener('click', function(event) {
        if(!modal.contains(event.target)) {
          previouslyFocusedInput.focus();
        }
      });
    }, 200); 
  }  
}
